import { PROJECT_PERMISSION } from '~/modules/common/enums';

export const hasEditProjectAndTeamPermission = (resourceRequest, project) => {
  return Boolean(
    (project || resourceRequest.project)?.permittedActionUris.includes(
      PROJECT_PERMISSION.EDIT_PROJECT
    ) &&
      (project || resourceRequest.project)?.permittedActionUris.includes(
        PROJECT_PERMISSION.EDIT_TEAM
      )
  );
};

export const hasResourceAllocationEditPermission = permissions => {
  return permissions.some(
    permission =>
      permission.permissionActionUri ===
        'urn:replicon:resource-assignment-action:edit-resource-assignments' ||
      permission.permissionActionUri ===
        'urn:replicon-webui:completed-resource-allocation:edit'
  );
};
